import { render, staticRenderFns } from "./tab-lu.vue?vue&type=template&id=75a1fdc4&scoped=true&"
import script from "./tab-lu.vue?vue&type=script&lang=js&"
export * from "./tab-lu.vue?vue&type=script&lang=js&"
import style0 from "./tab-lu.vue?vue&type=style&index=0&id=75a1fdc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a1fdc4",
  null
  
)

export default component.exports